import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "pa pt-05 pb-05 flex flex-justify-between flex-align-center" }
const _hoisted_2 = { class: "flex flex-column flex-align-center" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = { class: "pa small-text" }
const _hoisted_5 = { class: "flex flex-justify-between" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "gray3--text" }
const _hoisted_8 = { class: "flex flex-justify-between mt-05" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = {
  key: 0,
  class: "gray3--text"
}
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { class: "grid small-text flex-grow-1" }
const _hoisted_13 = ["textContent"]
const _hoisted_14 = ["textContent"]
const _hoisted_15 = ["textContent"]
const _hoisted_16 = { class: "mt-05" }
const _hoisted_17 = { class: "flex flex-column flex-align-start" }
const _hoisted_18 = ["textContent"]
const _hoisted_19 = {
  key: 0,
  class: "mt-05"
}
const _hoisted_20 = ["textContent"]
const _hoisted_21 = ["textContent"]
const _hoisted_22 = { class: "mt-05" }
const _hoisted_23 = {
  key: 2,
  class: "document document--download flex flex-align-center"
}
const _hoisted_24 = { class: "grid small-text flex-grow-1" }
const _hoisted_25 = ["textContent"]
const _hoisted_26 = ["textContent"]
const _hoisted_27 = ["textContent"]
const _hoisted_28 = { class: "mt-05" }
const _hoisted_29 = ["textContent"]
const _hoisted_30 = { class: "mt-05" }
const _hoisted_31 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_document_block_menu = _resolveComponent("document-block-menu")!

  return (_ctx.blockType === _ctx.blockTypes.block)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["document document--block", { "is-selected": _ctx.isSelected }]),
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleSelected()))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_document_block_menu, {
            onPreviewDocument: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadDocument(true))),
            onToggleDocument: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleSelected())),
            onShowRelatedDocuments: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showRelatedDocuments())),
            onShowVersionHistory: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showVersionDetail())),
            onDownloadDocument: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadDocument()))
          }),
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "circle" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("i", {
            class: _normalizeClass(["big mb", _ctx.iconClass])
          }, null, 2),
          _createElementVNode("b", {
            class: "document-type-title",
            textContent: _toDisplayString(_ctx.$t(_ctx.documentTypeKey))
          }, null, 8, _hoisted_3)
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("hr", { class: "mt-2" }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("b", {
              textContent: _toDisplayString(_ctx.$t(_ctx.primaryName))
            }, null, 8, _hoisted_6),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.document.primaryValue), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("b", {
              textContent: _toDisplayString(_ctx.$t(_ctx.secondaryName))
            }, null, 8, _hoisted_9),
            (!_ctx.document.secondaryValue.includes(";"))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.document.secondaryValue), 1))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "details-button",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.showBatchDetail()), ["stop"])),
                  textContent: _toDisplayString(_ctx.$t("DOCUMENTS.MULTIPLE_BATCHES"))
                }, null, 8, _hoisted_11))
          ])
        ])
      ], 2))
    : (_ctx.blockType === _ctx.blockTypes.row)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["document document--row flex flex-align-center", { "is-selected": _ctx.isSelected }]),
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.toggleSelected()))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["big", _ctx.iconClass])
          }, null, 2),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, [
              _createElementVNode("b", {
                textContent: _toDisplayString(_ctx.$t("DOCUMENTS.DOCUMENT_TYPE"))
              }, null, 8, _hoisted_13),
              _createElementVNode("div", {
                class: "mt-05",
                textContent: _toDisplayString(_ctx.$t(_ctx.documentTypeKey))
              }, null, 8, _hoisted_14)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("b", {
                textContent: _toDisplayString(_ctx.$t(_ctx.primaryName))
              }, null, 8, _hoisted_15),
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.document.primaryValue), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("b", {
                textContent: _toDisplayString(_ctx.$t(_ctx.secondaryName))
              }, null, 8, _hoisted_18),
              (!_ctx.document.secondaryValue.includes(";"))
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.document.secondaryValue || '-'), 1))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "details-button mt-05",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.showBatchDetail()), ["stop"])),
                    textContent: _toDisplayString(_ctx.$t("DOCUMENTS.MULTIPLE_BATCHES"))
                  }, null, 8, _hoisted_20))
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("b", {
                textContent: _toDisplayString(_ctx.$t("COMMON.DATE_CREATED"))
              }, null, 8, _hoisted_21),
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.formatDate(_ctx.document.uploadDate)), 1)
            ])
          ]),
          _createVNode(_component_document_block_menu, {
            menuPositionLeft: true,
            onPreviewDocument: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downloadDocument(true))),
            onToggleDocument: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toggleSelected())),
            onShowRelatedDocuments: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showRelatedDocuments())),
            onShowVersionHistory: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showVersionDetail())),
            onDownloadDocument: _cache[12] || (_cache[12] = ($event: any) => (_ctx.downloadDocument()))
          }),
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "circle mr-2 ml" }, null, -1))
        ], 2))
      : (_ctx.blockType === _ctx.blockTypes.download)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("i", {
              class: _normalizeClass(["big", _ctx.iconClass])
            }, null, 2),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", null, [
                _createElementVNode("b", {
                  textContent: _toDisplayString(_ctx.$t("DOCUMENTS.DOCUMENT_TYPE"))
                }, null, 8, _hoisted_25),
                _createElementVNode("div", {
                  class: "mt-05",
                  textContent: _toDisplayString(_ctx.$t(_ctx.documentTypeKey))
                }, null, 8, _hoisted_26)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("b", {
                  textContent: _toDisplayString(_ctx.$t(_ctx.primaryName))
                }, null, 8, _hoisted_27),
                _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.document.primaryValue), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("b", {
                  textContent: _toDisplayString(_ctx.$t(_ctx.secondaryName))
                }, null, 8, _hoisted_29),
                _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.document.secondaryValue), 1)
              ])
            ]),
            _createElementVNode("button", {
              class: "document-remove-button",
              type: "button",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.toggleSelected()))
            }, [
              _cache[18] || (_cache[18] = _createElementVNode("i", { class: "icons8-delete" }, null, -1)),
              _createElementVNode("span", {
                textContent: _toDisplayString(_ctx.$t("COMMON.REMOVE"))
              }, null, 8, _hoisted_31)
            ])
          ]))
        : _createCommentVNode("", true)
}